import RequestManager from "../../../../requests/RequestManager";
import StatisticsCountryDetailsTask from "src/requests/tasks/sports/CountryDetails/statisticsCountryDetailsTask";
import Translator from "../../../../requests/apa/Translator";
import Utils from "../../../../utils/Utils";
import Asset from "../../../../requests/apa/Asset";
import logger from 'src/utils/logger/logger';

export const getStatisticsCountryDetails = async (idLeague, teamViewParam, teamId) => {
	try {
		const statisticsCountryDetailsTask = new StatisticsCountryDetailsTask(idLeague, teamViewParam, teamId);
		const { response } = await RequestManager.addRequest(statisticsCountryDetailsTask);
		if(!response) return [];

        const { teamStatistics: { teamView, teamCard, statistics } } = response || {};

        const { featuredPlayers, recentResults, summary, team } = teamCard || {};

        const transformedTeam = team &&
             {
                teamId: team.teamId,
                name: team.name,
                shortName: team.shortName,
                crestUrl: team && team.crestUrl ? team.crestUrl : Asset.get('eventodeportivo_placeholder_imagen_escudo_1'),
                flagUrl: team && team.flagUrl ? team.flagUrl : Asset.get('eventodeportivo_placeholder_imagen_bandera_1'),
                color: team.primaryHex,
                isFavorited: team.isFavorite
            };

        const sortedRecentResults = [...recentResults].sort((a, b) => a.matchOrder - b.matchOrder);
        const transformedRecentResults = sortedRecentResults.map(match => {
            let labelFromKey = undefined;
            let matchStatusClassName = undefined;
            if (match.result === "WIN") {
                labelFromKey =  Utils.cutPlayerString(Translator.get('eventodeportivo_paises_fichasuperior_texto_ganado'), 1, undefined, '');
                matchStatusClassName = "--win";
            } else if (match.result === "LOSS") {
                labelFromKey =  Utils.cutPlayerString(Translator.get('eventodeportivo_paises_fichasuperior_texto_perdido'), 1, undefined, '');
                matchStatusClassName = "--loss";
            } else if (match.result === "DRAW") {
                labelFromKey =  Utils.cutPlayerString(Translator.get('eventodeportivo_paises_fichasuperior_texto_empate'), 1, undefined, '');
                matchStatusClassName = "--draw";
            }
            return {
                ...match,
                labelFromKey,
                matchStatusClassName
            }
        });

        const transformedFeaturedPlayers = (featuredPlayers || []).map(featuredPlayer => {
            return {
                category: featuredPlayer.category,
                headline: featuredPlayer.headline,
                playerImage: featuredPlayer && featuredPlayer.player && featuredPlayer.player.image ? featuredPlayer.player.image : Asset.get('eventodeportivo_placeholder_imagen_jugador_1'),
                playerName: featuredPlayer.player.name,
                playerNumber: featuredPlayer.player.number,
                playerId: featuredPlayer.player.playerId,
                playerPosition: featuredPlayer.player.position,
                playerValue: featuredPlayer.player.value
            }
        });


        // Transformar las "Estadísticas" para un acceso más fácil en el componente StatsBody.

        const { defensive, goalkeeping, offensive } = statistics || {};

        const transformedOffensive = (offensive || []).map((player) => {
            const statsObj = {};
            (player.stats || []).forEach((stat) => {
                statsObj[stat.code.toLowerCase()] = stat.value
            });
            return {
                playerName: player.name,
                jerseyNumber: player.number,
                photoUrl: player && player.image ? player.image : Asset.get('eventodeportivo_placeholder_imagen_jugador_1'),
                stats: statsObj
            }
        });

        const transformedDefensive = (defensive || []).map((player) => {
            const statsObj = {};
            (player.stats || []).forEach((stat) => {
                statsObj[stat.code.toLowerCase()] = stat.value
            });
            return {
                playerName: player.name,
                jerseyNumber: player.number,
                photoUrl: player && player.image ? player.image : Asset.get('eventodeportivo_placeholder_imagen_jugador_1'),
                stats: statsObj
            }
        });

        const transformedGoalkeeping = (goalkeeping || []).map((player) => {
            const statsObj = {};
            (player.stats || []).forEach((stat) => {
                statsObj[stat.code.toLowerCase()] = stat.value
            });
            return {
                playerName: player.name,
                jerseyNumber: player.number,
                photoUrl: player && player.image ? player.image : Asset.get('eventodeportivo_placeholder_imagen_jugador_1'),
                stats: statsObj
            }
        });

        const dataHeader = { transformedTeam, transformedRecentResults, transformedFeaturedPlayers, summary };
        const dataStats = { transformedOffensive, transformedDefensive, transformedGoalkeeping };

        return { dataHeader, dataStats };
	} catch (error) {
		logger.error('Error getting statistics country details:', error);
		return { dataHeader: {}, dataStats: {} };
	}
}



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/services/CountryDetailsServices/getStatisticsCountryDetails.js